const crypto = require("crypto");

export const authHash = () => {
  return crypto.createHmac("sha512", process.env.REACT_APP_API_KEY)
      .update( process.env.REACT_APP_APP_ID)
      .digest("hex");
}